import { Outlet } from 'react-router-dom';

export const ReadersOutlet = () => <Outlet />;
